// ModalContext.jsx
import { createContext, ReactNode, useContext, useState } from "react";
import "./ModalContext.css";

const ModalContext = createContext<ModalContextType | null>(null);

export type ModalContextType = {
    showModal: (a: any) => void;
    hideModal: () => void;
};

interface Props {
    children: ReactNode;
}

export function ModalProvider({ children }: Props) {
    const [modalContent, setModalContent] = useState<ReactNode | null>(null);

    const showModal = (content: ReactNode) => setModalContent(content);
    const hideModal = () => setModalContent(null);

    return (
        <ModalContext.Provider value={{ showModal, hideModal }}>
            {children}
            {modalContent && (
                <div className="modal-backdrop">
                    <div className="modal">{modalContent}</div>
                </div>
            )}
        </ModalContext.Provider>
    );
}

export function useModal() {
    const ctx = useContext(ModalContext);
    if (!ctx)
        throw new Error("useModal must be used inside of a ModalProvider");
    return ctx;
}
